// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React from 'react';
export class ContextMenuItemSeparator extends React.Component {
    render() {
        return React.createElement("div", { className: "new-context-menu-separator" });
    }
}
